import React from 'react';
import MenuSportButton from './MenuSportButton';

export default function Menu(props) {
    let sports = props.sports;

    return (
        <>
            {sports.map(s => {
                return <MenuSportButton key={s.id}
                                        data={s}
                        />;
            })}
        </>    
    );
}
